import * as React from 'react';
import './../index.css';
import './../fonts/Bakerie/BakerieSmoothCondensed-Black.otf';
import { Timestamp } from "firebase/firestore";

import {
  Button,
  Container,
  Form,
  Row,
  Col,
  Table,
} from "react-bootstrap";
import {
  Settings, getSettings, documentToSettings, saveSettings, recordHistory,
  loadHistoryMap
} from '../data/SettingsData';
import { getReferenceName } from '../utils/ReferendeUtils';



export class SettingsForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      settings: new Settings(),
      validated: false,
      isOpen: false,
      showForm: false,
      modalString: "",
      deleteDocRef: "",
      deleteDocDescription: "",
      isDeleteProductConfirmOpen: false,
      historyMap: new Map(),
      dataLoading: true,
    };

    this.changeValue = this.changeValue.bind(this);
    this.handleClose = this.handleClose(this);
  }

  handleClose = () => this.setState({ isOpen: false });


  toggleDeleteModal = (docRef, description) => {
    this.setState({
      deleteDocRef: docRef,
      deleteDocDescription: description,
      isDeleteProductConfirmOpen: !this.state.isDeleteProductConfirmOpen,
    });
  }

  handleDelete = async (docRef) => {

    let tempSettings = this.state.Settings;
    this.setState({
      deleteDocRef: "",
      settings: tempSettings,
    });
  }
  async getExistingSetting() {

    try {
      let existingDoc = await getSettings(this.props.docRef);
      let existingSettings = documentToSettings(existingDoc);
      let newHistoryMap = new Map();

      if (existingSettings.history && existingSettings.history.length !== 0) {
        newHistoryMap = await loadHistoryMap(existingSettings.history);
      }

      this.setState({
        settings: existingSettings,
        historyMap: newHistoryMap,
      });
    } catch (e) {
      console.log("Error getting document ref:" + this.props.docRef);
    }
  }


  async loadData() {
    if (this.props.docRef !== '') {
      this.getExistingSetting();
    }
  }

  componentDidMount() {
    this.loadData();
  }


  changeValue(event) {
    this.props.setDataChanged(true);
    let tempSettings = this.state.settings;

    if (event.target.id === 'user') {
      tempSettings.user = event.target.value;
    } else if (event.target.id === 'hourly_labor_rate') {
      tempSettings.hourly_labor_rate = event.target.value;
    } else if (event.target.id === 'low_profit_index') {
      tempSettings.low_profit_index = event.target.value;
    } else if (event.target.id === 'profit_index') {
      tempSettings.profit_index = event.target.value;
    }  else if (event.target.id === 'title_text') {
      tempSettings.title_text = event.target.value;
    } 

    this.setState({ settings: tempSettings });

  }

  saveChangedEvent = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      this.setState({ validated: true });
      return;
    }

    let documentName = "";
    if (this.props.docRef === '') {
      documentName = getReferenceName(this.state.settings.user);
    } else {
      documentName = this.props.docRef;
    }

    let newHistoryList = new Array();
    let newHistoryMap = new Map();
    let now = Timestamp.now();

    if (this.props.mode === 'Edit') {
      if (this.state.settings.history && this.state.settings.history.length !== 0) {
        newHistoryList = this.state.settings.history;
      }
      await recordHistory(newHistoryList, now, this.state.settings, documentName);
    }

    let docData = {
      user: this.state.settings.user,
      hourly_labor_rate: (this.state.settings.hourly_labor_rate ? this.state.settings.hourly_labor_rate : 0),
      low_profit_index: (this.state.settings.low_profit_index ? this.state.settings.low_profit_index : 0),
      profit_index: (this.state.settings.profit_index ? this.state.settings.profit_index : 0),
      title_text: (this.state.settings.title_text ? this.state.settings.title_text : 0),
      last_update: now,
      history: newHistoryList,
    };

    saveSettings(documentName, docData);

    this.setState({
      settings: new Settings(),
      validated: false,
      isOpen: false,
      modalString: "Settings added!",
      deleteDocRef: "",
      deleteDocDescription: "",
      historyMap: newHistoryMap,
    });
    /**
     * toggle the show form so the add/edit is not shown.
     */
    this.props.setDataChanged(false);
    this.props.toggleForm();
  }

  renderHistoryTableRow = (historyDocRef, historyRecord) => {
    let updatedDate = historyRecord.updateDate.toDate().toString();
    let oldValue = historyRecord.oldValue;
    let newValue = historyRecord.newValue;
  
    return (
      <tr>
        <td className='history_cell'>{updatedDate}</td>
        <td className='history_cell'> {historyRecord.field}</td>
        <td className='history_cell'>{oldValue}</td>
        <td className='history_cell'>{newValue}</td>
      </tr>
    );
  }

  render() {
    let historyMap = this.state.historyMap;
    let lastUpdatedString = "";
    if (this.state.settings.last_update) {
      lastUpdatedString = this.state.settings.last_update.toDate().toString();
    }

    return (
      <>
        {
          /* 
          * Settings 
          */
        }
        <Container fluid>
          <h1>Settings {this.props.mode} "{this.state.settings.user}"</h1>
          <Form noValidate validated={this.state.validated} onSubmit={this.saveChangedEvent}>
            <Button
              size="sm"
              variant="dark"
              onClick={() => { this.props.toggleForm() }}>
              Cancel
            </Button>{' '}
            <Button
              size="sm"
              disabled={this.props.mode === 'View'}
              variant="dark"
              type="submit">
              Save
            </Button>
             <Row className="mb-3">
               <Form.Label as={Col} htmlFor="title_text">Web Page Title:</Form.Label>
             </Row>
             <Row className="mb-3">
               <Form.Control
                 as="textarea"
                 disabled={this.props.mode === 'View'}
                 value={this.state.settings.title_text}
                 placeholder="Title Text..."
                 id="title_text"
                 onChange={this.changeValue}
               />
             </Row>
            <Row>
              <Col>              
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="name">User:</Form.Label>
                  <Form.Control
                    disabled={this.props.mode === 'View'}
                    required
                    value={this.state.settings.user}
                    placeholder="User"
                    id="user"
                    onChange={this.changeValue}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="name">Labor Rate:</Form.Label>
                  <Form.Control
                    disabled={this.props.mode === 'View'}
                    value={this.state.settings.hourly_labor_rate}
                    placeholder="Hourly Labor Rate"
                    id="hourly_labor_rate"
                    onChange={this.changeValue}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="name">Low Profit Index:</Form.Label>
                  <Form.Control
                    disabled={this.props.mode === 'View'}
                    value={this.state.settings.low_profit_index}
                    placeholder="Low Profit Index"
                    id="low_profit_index"
                    onChange={this.changeValue}
                  />
                </Form.Group> 
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="name">High Profit Index:</Form.Label>
                  <Form.Control
                    disabled={this.props.mode === 'View'}
                    value={this.state.settings.profit_index}
                    placeholder="High Profit Index"
                    id="profit_index"
                    onChange={this.changeValue}
                  />
                </Form.Group>                                               
              </Col>
            </Row>
            <Row>
              <Container>
                <Button
                  size="sm"
                  variant="dark"
                  onClick={() => { this.props.toggleForm() }}>
                  Cancel
                </Button>{' '}
                <Button
                  size="sm"
                  disabled={this.props.mode === 'View'}
                  variant="dark"
                  type="submit">
                  Save
                </Button>
              </Container>
            </Row>
            <Row className="mb-3">
              <Form.Label htmlFor="history">History:</Form.Label>
              <Table
                disabled
                id="history"
                bordered>
                <thead>
                  <tr>
                    <th>Update Date</th>
                    <th>Field</th>
                    <th>Old Value</th>
                    <th>New Value</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    [...historyMap].map(([key, value]) => {
                      return this.renderHistoryTableRow(key, value);
                    }
                    )
                  }
                </tbody>
              </Table>
            </Row>
          </Form>
        </Container >
      </>
    );

  }
}
